var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServicesIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1218 10.4768C13.7313 10.0862 13.0981 10.0862 12.7076 10.4768L12.0005 11.1839C11.2194 11.9649 9.95308 11.9649 9.17203 11.1839C8.39098 10.4028 8.39098 9.13644 9.17203 8.35539L14.8027 2.72324C16.9066 2.24729 19.2013 2.82831 20.8393 4.46631C23.2587 6.88567 23.3721 10.7378 21.1797 13.2915L19.0715 15.4265L14.1218 10.4768ZM3.16162 4.46631C5.33501 2.29292 8.6646 1.98039 11.1705 3.52872L7.75781 6.94118C6.19572 8.50328 6.19572 11.036 7.75781 12.5981C9.27258 14.1128 11.7 14.1587 13.27 12.7358L13.4147 12.5981L17.6573 16.8407L13.4147 21.0834C12.6336 21.8644 11.3673 21.8644 10.5863 21.0834L3.16162 13.6587C0.62321 11.1203 0.62321 7.00471 3.16162 4.46631Z",
    fill: "#22428F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesIconActive);
export default __webpack_public_path__ + "static/media/services-icon-active.bbd8184c8972b272539c76c24db98563.svg";
export { ForwardRef as ReactComponent };